import { render, staticRenderFns } from "./FeedbackBtn.vue?vue&type=template&id=45667c80&scoped=true&"
import script from "./FeedbackBtn.vue?vue&type=script&lang=js&"
export * from "./FeedbackBtn.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackBtn.vue?vue&type=style&index=0&id=45667c80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45667c80",
  null
  
)

export default component.exports